const initialState = {
  totalPorBuque: null
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'MONITOR_EMBARQUE_POR_BUQUE':
      return {
        ...state,
        totalPorBuque: action.data
      }

    default:
      return state
  }
}
